import BoxShadowContainer from "components/UIComponents/BoxShadowContainer";
import { PaymentMethod } from "../paymentMethods";
import { Box, Center, Heading } from "@chakra-ui/react";

const PaymentMethodComponent = (props: PaymentMethod) => {
  return (
    <Box
      cursor="pointer"
      onClick={props.handleOnClick}
      className="payment-method"
    >
      <BoxShadowContainer className={props.isSelected ? "method-selected" : ""}>
        <Center className="payment-method-image-container">
          {props.image}
        </Center>
        <Heading size="sm" textAlign="center" fontWeight="medium" mt={5}>
          {props.name}
        </Heading>
      </BoxShadowContainer>
    </Box>
  );
};

export default PaymentMethodComponent;